import React, { useState, useEffect, useRef } from "react";
export const SearchableSelectBox = (props) => {
  let options=props.data
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [selectedOption, setSelectedOption] = useState(props.selected !==""?props.selected:"Search");
  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownRef = useRef(null);

  const handleSearch = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    const regex = new RegExp(term, "i");
    const filtered = options.filter((option) => regex.test(option.name) || regex.test(option.id));
    setFilteredOptions(filtered);
  };

  const handleSelect = (option) => {
    props.onSearchHandle(option)
    setSelectedOption(option);
    setShowDropdown(false);
    setSearchTerm(""); // Reset search term
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
useEffect(()=>{
  setFilteredOptions(props.data)
},[props.data])
  return (

    <div ref={dropdownRef} style={{ width: "100%", position: "relative",marginTop:"18px" }}>
       <label class="form-label text-white fw-bold" for="exampleFormControlSelect2" ></label>
      <input
        type="text"
        value={searchTerm}
        onChange={handleSearch}
        onFocus={() => setShowDropdown(true)}
        placeholder={selectedOption}
       className="searchable"
        style={{ 
          width: "100%",
           padding: "8px", 
          boxSizing: "border-box",
          background:"transparent", 
          color:"white",
          border:"1px solid rgba(255,255,255,.3)" ,
          borderRadius:"4px" 
          }}
      />
      {showDropdown && (
        <ul
          style={{
            listStyleType: "none",
            padding: 0,
            margin: 0,
            border: "1px solid #ccc",
            maxHeight: "150px",
            overflowY: "auto",
            position: "absolute",
            width: "100%",
            background: "#fff",
            zIndex: 1000,
            color:"#343434"
          }}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map((val, index) => (
              <li
                key={index}
                onClick={() => handleSelect(val.id)}
                style={{
                  padding: "5px",
                  cursor: "pointer",
                  fontSize:"11px"
                 
                }}
              >
                {`${val.id} (${val.name})`}
              </li>
            ))
          ) : (
            <li style={{ padding: "8px", textAlign: "center" }}>No results</li>
          )}
        </ul>
      )}
     
    </div>
  );
};
